module.exports = __webpack_public_path__ + "static/media/Backdrop_Poker.ce851964.png";